import React, { FC } from 'react'
import { DismissFilled } from '@fluentui/react-icons'

import { ButtonWithTooltip } from './ButtonWithTooltip'
import { CLOSE_DRAWER } from './constants'

interface ICloseDrawerButtonProps {
  onCloseDrawer: () => void
}
export const CloseDrawerButton: FC<ICloseDrawerButtonProps> = ({ onCloseDrawer }) => (
  <ButtonWithTooltip
    type='text'
    aria-label='Dismiss Button'
    icon={<DismissFilled />}
    onClick={onCloseDrawer}
    tooltipText={CLOSE_DRAWER}
    disabled={false}
  />
)
